// extracted by mini-css-extract-plugin
export default {"root":"AdsenseForSearch-root","loaded":"AdsenseForSearch-loaded","title":"AdsenseForSearch-title"};